<template>
<div class="chapter">
<div class="inner_page">
<div id="Author-Note">
<h2 class="fm-title1"><a id="page_10"></a><span class="bold">A Note from the Author</span>
</h2>
<p class="noindent">I know what it’s like to be unseen, unheard, and unhappy. I know what it’s like to feel so much and have so much to say but you can’t find the words to express what you are going through. I know what it’s like to feel tired, a deep fatigue preventing you from absorbing joy. It’s lonely. But you are not alone. We’re in this together.</p>
<p class="noindent">The good news is that you’ve survived 100 percent of your toughest days and I will get you through the rest.</p>
<div class="img_container-r"><img alt="images" src="images/sin.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Author-Note.vue?0689167a